/**
 * AI 제안서(피치) 도우미 API — tech_spec.md 8-2절
 */
import axios from 'axios';
import { API_ORIGIN } from '../config/runtime';

const client = axios.create({ baseURL: `${API_ORIGIN}/api/proposal-ai`, timeout: 60000 });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export interface ProposalDraft {
  title: string;
  opening: string;
  fitReasons: { requirement: string; matchedExperience: string; why: string }[];
  proposedPlan: string[];
  portfolioHighlight: string | null;
  closing: string;
}

export const proposalAiAPI = {
  generate: async (projectId: number, lang: 'ko' | 'en' = 'ko') => {
    const res = await client.post('/generate', { projectId, lang });
    return res.data as { success: boolean; message?: string; code?: string; data?: { draftId: number; projectId: number; draft: ProposalDraft } };
  },
};

export default proposalAiAPI;
